import { apiGet, apiPut } from '../../../adapters/api-client/api';

export interface UserPreferences {
  language?: string;
  timezone?: string;
}

export interface TeacherVerification {
  verificationStatus?: string;
  verificationDate?: string;
}

export interface UserProfile {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  status: string;
  preferences?: UserPreferences;
  createdAt: string;
  updatedAt: string;
  /**
   * Present for TEACHER accounts only. This is the field the server actually
   * enforces at the publish gate — not the application state, which describes
   * where a teacher sits in review (S11.1).
   */
  teacherProfile?: TeacherVerification;
}

/**
 * GET /users/me — the authenticated user's own profile.
 *
 * Carries `teacherProfile.verificationStatus` for teachers, which is what the
 * publish gate enforces. Screens used to infer publish-ability from the
 * application state because this response omitted the field; that inference was
 * a proxy, and the two can disagree (S11.1).
 */
export function getMyProfile(): Promise<UserProfile> {
  return apiGet<UserProfile>('/api/v1/users/me');
}

/** PUT /users/me — only these fields are accepted by UpdateProfileDto. */
export function updateMyProfile(data: {
  firstName: string;
  lastName: string;
  preferences?: UserPreferences;
}): Promise<UserProfile> {
  return apiPut<UserProfile>('/api/v1/users/me', data);
}
